var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeActivestudents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.677,
    height: 43.677,
    viewBox: "0 0 43.677 43.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_profile-tick",
    "data-name": "vuesax/bulk/profile-tick",
    transform: "translate(-300 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-tick",
    transform: "translate(300 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.644,0a8.637,8.637,0,0,0-.218,17.271,1.468,1.468,0,0,1,.4,0h.127A8.638,8.638,0,0,0,8.644,0Z",
    transform: "translate(13.194 3.64)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M22.057,2.539C16.98-.846,8.7-.846,3.585,2.539A7.131,7.131,0,0,0,0,8.4a7.123,7.123,0,0,0,3.567,5.842,16.815,16.815,0,0,0,9.245,2.566,16.815,16.815,0,0,0,9.245-2.566,7.18,7.18,0,0,0,3.567-5.878A7.137,7.137,0,0,0,22.057,2.539Z",
    transform: "translate(9.027 23.231)",
    fill: "#387f75",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.421,6.843a1.212,1.212,0,0,1-.8-.328L.328,4.222a1.142,1.142,0,0,1,0-1.6,1.142,1.142,0,0,1,1.6,0L3.421,4.113,7.207.328a1.142,1.142,0,0,1,1.6,0,1.142,1.142,0,0,1,0,1.6L4.222,6.515A1.129,1.129,0,0,1,3.421,6.843Z",
    transform: "translate(17.271 28.208)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H43.677V43.677H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActivestudents);
export default __webpack_public_path__ + "static/media/home-activestudents.e48d66a957162471a83f2006fe9aa102.svg";
export { ForwardRef as ReactComponent };